import $ from "jquery";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Http from "../Common/Http";
import Accounts from "./Sidebar/Accounts";
import Expenses from "./Sidebar/Expenses";
import Deposits from "./Sidebar/Deposits";
import ProductSetup from "./Sidebar/ProductSetup";
import PurchaseReturn from "./Sidebar/PurchaseReturn";
import Production from "./Sidebar/Production";
import Sales from "./Sidebar/Sales";
import SecondarySales from "./Sidebar/SecondarySales";
import StaffManagement from "./Sidebar/StaffManagement";
import SupplyChain from "./Sidebar/SupplyChain";
import Workplace from "./Sidebar/Workplace";

const Sidebar = () => {
  const [active, setActive] = useState(window.location.pathname);
  const [receiveData, setReceiveData] = useState([]);
  const location = useLocation();
  const [user, setUser] = useState({});

  const fetchData = () => {
    Http.get("/staff-type-check").then((res) => {
      setReceiveData(res.data);
    });
    Http.get("/me").then((res) => {
      setUser(res.data.data);
    });
  };

  const [badgeNotification, setBadgeNotification] = useState();

  const fetchNotification = async () => {
    try {
      const res = await Http.get("/badge-notification");
      setBadgeNotification(res.data);
    } catch (error) {
      console.error("Error fetching notification:", error);
    }
  };

  // Fetch /module-counts periodically
  useEffect(() => {
    const fetchModuleCounts = () => { };

    fetchModuleCounts(); // Initial fetch

    const intervalId = setInterval(fetchModuleCounts, 300000); // Fetch every 10 seconds

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  useEffect(() => {
    fetchData();
    fetchNotification();

    // Set interval to call every 5 minutes (300,000 ms)
    const intervalId = setInterval(fetchNotification, 30000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // Update active state when location changes
  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  const handleSidebarClick = (path) => {
    setActive(path);
  };

  useEffect(() => {
    $(".show-sub + .nav-sub").slideDown();

    $(".with-sub").on("click", function (e) {
      e.preventDefault();
      // Collapse all other submenus before toggling the current one
      $(".nav-sub").not($(this).next()).slideUp();
      $(".with-sub").not($(this)).removeClass("show-sub");

      // Now toggle the clicked submenu
      $(this).next().slideToggle();
      $(this).toggleClass("show-sub");
    });
  }, [receiveData]);

  if (location.pathname === "/" || location.pathname === "/login") return null;

  return (
    <div>
      <div className="am-sideleft">
        <ul className="nav am-sideleft-tab">
          <li className="nav-item w-100">
            <p className="nav-link tx-18">
              {" "}
              <i className="fa fa-user"></i> &nbsp; {user.name}{" "}
            </p>
            {/* <a href="#mainMenu" className="nav-link">
              <i className="icon ion-ios-menu-outline tx-24" />
              <i className="fa fa-bars text-12"></i>
              <p className="nav-link" > {user.name} </p>
            </a> */}
          </li>
          {/* <li className="nav-item">
            <a href="#emailMenu" className="nav-link">
              <i className="icon ion-ios-email-outline tx-24" />
            </a>
          </li>
          <li className="nav-item">
            <a href="#chatMenu" className="nav-link">
              <i className="icon ion-ios-chatboxes-outline tx-24" />
            </a>
          </li>
          <li className="nav-item">
            <a href="#settingMenu" className="nav-link">
              <i className="icon ion-ios-gear-outline tx-24" />
            </a>
          </li> */}
        </ul>
        <div className="tab-content">
          <div id="mainMenu" className="tab-pane active">
            {/* {sidebarComponent} */}
            <ul className="nav am-sideleft-menu">
              <li className="nav-item">
                <Link
                  to="/dashboard"
                  className={`nav-link ${active === "/dashboard" ? "active" : ""
                    }`}
                  onClick={() => handleSidebarClick("/dashboard")}
                >
                  <i className="fa fa-tachometer" aria-hidden="true"></i>
                  <span>Dashboard</span>
                </Link>
              </li>

              {/* {(receiveData === "admin" || receiveData === "hr") && (
                <BasicSetup onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* {(receiveData === "admin" || receiveData === "hr") && (
                <StaffManagement
                  onMenuClick={handleSidebarClick}
                  active={active}
                />
              )} */}

              {/* Payroll */}
              {/* {(receiveData === "admin" || receiveData === "hr") && (
                <Payroll onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* Accounts */}
              {(receiveData === "admin" || receiveData === "accounts" || receiveData === "admin_viewer") && (
                // <Accounts onMenuClick={handleSidebarClick} active={active} />
                <>
                  <li className="nav-item">
                    <p className="reportWatermark nav-link">Accounts</p>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/banks"
                      className={`nav-link ${active === "/banks" ? "active" : ""
                        }`}
                      onClick={() => setActive("/banks")}
                    >
                      <i className="fa fa-university" aria-hidden="true"></i>
                      &nbsp;&nbsp; Banks
                    </Link>
                  </li>
                  {receiveData === "admin" && <Deposits />}
                  {receiveData === "admin" && <Expenses />}
                  {/* <li className="nav-item">
                    <Link
                      to="/shops"
                      className={`nav-link ${
                        active === "/shops" ? "active" : ""
                      }`}
                      onClick={() => setActive("/shops")}
                    >
                      <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                      &nbsp;&nbsp; Shops
                    </Link>
                  </li> */}
                  {receiveData !== "admin" && (
                    <>
                      <li className="nav-item">
                        <Link
                          to="/deposit-categories"
                          className={`nav-link ${active === "/deposit-categories" ? "active" : ""
                            }`}
                          onClick={() => setActive("/deposit-categories")}
                        >
                          <i className="fa fa-list" aria-hidden="true"></i>
                          &nbsp;&nbsp; Deposit Categories
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/deposits"
                          className={`nav-link ${active === "/deposits" ? "active" : ""
                            }`}
                          onClick={() => setActive("/deposits")}
                        >
                          <i className="fa fa-money" aria-hidden="true"></i>
                          &nbsp;&nbsp; Deposits
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/daily-collection"
                          className={`nav-link ${active === "/daily-collection" ? "active" : ""
                            }`}
                          onClick={() => setActive("/daily-collection")}
                        >
                          <i className="fa fa-money" aria-hidden="true"></i>
                          &nbsp;&nbsp; Daily Collections
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="/expense-categories"
                          className={`nav-link ${active === "/expense-categories" ? "active" : ""
                            }`}
                          onClick={() => setActive("/expense-categories")}
                        >
                          <i className="fa fa-list" aria-hidden="true"></i>
                          &nbsp;&nbsp; Expense Categories
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/expenses"
                          className={`nav-link ${active === "/expenses" ? "active" : ""
                            }`}
                          onClick={() => setActive("/expenses")}
                        >
                          <i
                            className="fa fa-credit-card"
                            aria-hidden="true"
                          ></i>
                          &nbsp;&nbsp; Expenses
                        </Link>
                      </li>
                    </>
                  )}

                  <li className="nav-item">
                    <Link
                      to="/fund-transfers"
                      className={`nav-link ${active === "/fund-transfers" ? "active" : ""
                        }`}
                      onClick={() => setActive("/fund-transfers")}
                    >
                      <i className="fa fa-exchange" aria-hidden="true"></i>
                      &nbsp;&nbsp; Fund Transfers
                    </Link>
                  </li>

                  {receiveData !== "admin" && (
                    <>
                      <li className="nav-item">
                        <Link
                          to="/vendor-payments"
                          className={`nav-link ${active === "/vendor-payments" ? "active" : ""
                            }`}
                          onClick={() => setActive("/vendor-payments")}
                        >
                          <i className="fa fa-truck" aria-hidden="true"></i>
                          &nbsp;&nbsp; Vendor Payments
                        </Link>
                      </li>
                    </>
                  )}

                  {/* Reports  */}
                  {receiveData !== "admin" && (
                    <>
                      <li className="nav-item">
                        <p className="reportWatermark nav-link">Reports</p>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/cash-flow-statement"
                          className={`nav-link ${active === "/cash-flow-statement" ? "active" : ""
                            }`}
                          onClick={() => setActive("/cash-flow-statement")}
                        >
                          <i
                            className="fa fa-credit-card"
                            aria-hidden="true"
                          ></i>
                          &nbsp;&nbsp; Cash Flow Statement
                        </Link>
                      </li>
                      {(receiveData === "admin" ||
                        receiveData === "production" ||
                        receiveData === "gm" ||
                        receiveData === "accounts") && (
                          <>
                            <li className="nav-item">
                              <Link
                                to="/production-wise-stock"
                                className={`nav-link ${active === "/production-wise-stock"
                                  ? "active"
                                  : ""
                                  }`}
                                onClick={() =>
                                  setActive("/production-wise-stock")
                                }
                              >
                                <i className="fa fa-building"></i>
                                &nbsp;&nbsp; Kitchen wise stock
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/handi-wise-stock"
                                className={`nav-link ${active === "/handi-wise-stock" ? "active" : ""
                                  }`}
                                onClick={() => setActive("/handi-wise-stock")}
                              >
                                <i className="fa fa-building"></i>
                                &nbsp;&nbsp; Handi wise stock
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/handi-rcv-vs-pos-sales-report"
                                className={`nav-link ${active === "/handi-rcv-vs-pos-sales-report"
                                  ? "active"
                                  : ""
                                  }`}
                                onClick={() =>
                                  setActive("/handi-rcv-vs-pos-sales-report")
                                }
                              >
                                <i className="fa fa-building"></i>
                                &nbsp;&nbsp; Handi Rcv Vs POS Sales
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/requisition-vs-production"
                                className={`nav-link ${active === "/requisition-vs-production"
                                  ? "active"
                                  : ""
                                  }`}
                                onClick={() =>
                                  setActive("/requisition-vs-production")
                                }
                              >
                                <i className="fa fa-building"></i>
                                &nbsp;&nbsp; Requisition Vs Production
                              </Link>
                            </li>
                          </>
                        )}

                      {/* {(receiveData == "admin" || receiveData === "supplichain" || receiveData === "gm") && (
                    <li className="nav-item">
                      <Link
                        to="/handi-pos-sales-report"
                        className={`nav-link ${
                          active === "/handi-pos-sales-report" ? "active" : ""
                        }`}
                        onClick={() => setActive("/handi-pos-sales-report")}
                      >
                        <i className="fa fa-building"></i>
                        &nbsp;&nbsp; Handi vs POS Sales Report
                      </Link>
                    </li>
                  )} */}
                      <li className="nav-item">
                        <Link
                          to="/reports/financial-summary"
                          className={`nav-link ${active === "/reports/financial-summary"
                            ? "active"
                            : ""
                            }`}
                          onClick={() =>
                            setActive("/reports/financial-summary")
                          }
                        >
                          <i className="fa fa-table" aria-hidden="true"></i>
                          &nbsp;&nbsp; Daily Cash Statement
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/reports/deposit-categories-ledger"
                          className={`nav-link ${active === "/reports/deposit-categories-ledger"
                            ? "active"
                            : ""
                            }`}
                          onClick={() =>
                            setActive("/reports/deposit-categories-ledger")
                          }
                        >
                          <i
                            className="fa fa-plus-circle"
                            aria-hidden="true"
                          ></i>
                          &nbsp;&nbsp; Deposit Categories Ledger
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/reports/expense-categories-ledger"
                          className={`nav-link ${active === "/reports/expense-categories-ledger"
                            ? "active"
                            : ""
                            }`}
                          onClick={() =>
                            setActive("/reports/expense-categories-ledger")
                          }
                        >
                          <i className="fa fa-list-alt" aria-hidden="true"></i>
                          &nbsp;&nbsp; Expense Categories Ledger
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/reports/get-bank-ledger-summary"
                          className={`nav-link ${active === "/reports/get-bank-ledger-summary"
                            ? "active"
                            : ""
                            }`}
                          onClick={() =>
                            setActive("/reports/get-bank-ledger-summary")
                          }
                        >
                          <i className="fa fa-building" aria-hidden="true"></i>
                          &nbsp;&nbsp; Bank Ledger Summary
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/reports/vendor-ledger"
                          className={`nav-link ${active === "/reports/vendor-ledger" ? "active" : ""
                            }`}
                          onClick={() => setActive("/reports/vendor-ledger")}
                        >
                          <i className="fa fa-users" aria-hidden="true"></i>
                          &nbsp;&nbsp; Vendor Ledger
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/reports/vendor-ledger-summary"
                          className={`nav-link ${active === "/reports/vendor-ledger-summary"
                            ? "active"
                            : ""
                            }`}
                          onClick={() =>
                            setActive("/reports/vendor-ledger-summary")
                          }
                        >
                          <i className="fa fa-file-text" aria-hidden="true"></i>
                          &nbsp;&nbsp; Vendor Ledger Summary
                        </Link>
                      </li>
                      {/* <li className="nav-item">
                    <Link
                      to="/vendor-payments"
                      className={`nav-link ${active === "/vendor-payments" ? "active" : ""}`}
                      onClick={() => setActive("/vendor-payments")}
                    >
                      <i className="fa fa-truck" aria-hidden="true"></i>
                      &nbsp;&nbsp; Vendor Payments
                    </Link>
                  </li> */}
                    </>
                  )}
                </>
              )}

              {/* Supply Chain */}
              {(receiveData === "admin" || receiveData === "supply_chain" || receiveData === "admin_viewer") && (
                <>
                  <li className="nav-item">
                    <p className="reportWatermark nav-link">Supply Chain</p>
                  </li>
                  {/* // <SupplyChain role={receiveData} onMenuClick={handleSidebarClick} active={active} /> */}
                  <li className="nav-item">
                    <Link
                      to="/vendors"
                      className={`nav-link ${active === "/vendors" ? "active" : ""
                        }`}
                      onClick={() => setActive("/vendors")}
                    >
                      <i className="fa fa-users" aria-hidden="true"></i>
                      &nbsp;&nbsp; Vendors
                    </Link>
                  </li>

                  <ProductSetup />

                  <PurchaseReturn />

                  <li className="nav-item">
                    <Link
                      to="/direct-issue"
                      className={`nav-link ${active === "/direct-issue" ? "active" : ""
                        }`}
                      onClick={() => setActive("/direct-issue")}
                    >
                      <i className="fa fa-share-square" aria-hidden="true"></i>
                      &nbsp;&nbsp; Direct Issue/out
                    </Link>
                  </li>

                </>
              )}

              {(receiveData === "admin" || receiveData === "production" || receiveData === "admin_viewer") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/receipe"
                      className={`nav-link ${active === "/receipe" ? "active" : ""
                        }`}
                      onClick={() => setActive("/receipe")}
                    >
                      <i className="fa fa-book" aria-hidden="true"></i>
                      &nbsp;&nbsp; Recipe
                    </Link>
                  </li>
                </>
              )}

              {(receiveData === "admin" ||
                receiveData === "supply_chain" ||
                receiveData === "gm" ||
                receiveData === "production" || receiveData === "admin_viewer") && (
                  <>
                    <li className="nav-item">
                      {/* <Link
                      to="/requisition-production"
                      className={`nav-link ${
                        active === "/requisition-production" ? "active" : ""
                      }`}
                      onClick={() => setActive("/requisition-production")}
                    >
                      <i className="fa fa-list-alt" aria-hidden="true"></i>
                      &nbsp;&nbsp; Requisition
                      {receiveData === "supply_chain" && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {badgeNotification?.ApprovedRequisitonProduction}
                          </span>
                        </>
                      )}
                      {receiveData === "gm" && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {badgeNotification?.NotApprovedRequisitonProduction}
                          </span>
                        </>
                      )}
                      {receiveData === "production" && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {badgeNotification?.IssueCount}
                          </span>
                        </>
                      )}
                    </Link> */}
                      <Link
                        to="/requisition-production-with-batch"
                        className={`nav-link ${active === "/requisition-production-with-batch"
                          ? "active"
                          : ""
                          }`}
                        onClick={() =>
                          setActive("/requisition-production-with-batch")
                        }
                      >
                        <i className="fa fa-list-alt" aria-hidden="true"></i>
                        &nbsp;&nbsp; Requisition With Batch
                        {receiveData === "supply_chain" && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.ApprovedRequisitonProduction}
                            </span>
                          </>
                        )}
                        {receiveData === "gm" && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.NotApprovedRequisitonProduction}
                            </span>
                          </>
                        )}
                        {receiveData === "production" && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.IssueCount}
                            </span>
                          </>
                        )}
                      </Link>
                    </li>
                  </>
                )}

              {/* {(receiveData === "admin" ||
                receiveData === "supply_chain" ) && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/issue"
                      className={`nav-link ${
                        active === "/issue" ? "active" : ""
                      }`}
                      onClick={() => setActive("/issue")}
                    >
                      <i className="fa fa-share-square" aria-hidden="true"></i>
                      &nbsp;&nbsp; Issue/out
                    </Link>
                  </li>
                </>
              )} */}

              {(receiveData === "admin" ||
                receiveData === "production" ||
                receiveData === "kitchen" ||
                receiveData === "kitchen_manager" || receiveData === "admin_viewer") && (
                  <>
                    {(receiveData === "admin" ||
                      receiveData === "production") && (
                        <li className="nav-item">
                          <Link
                            to="/production"
                            className={`nav-link ${active === "/production" ? "active" : ""
                              }`}
                            onClick={() => setActive("/production")}
                          >
                            <i className="fa fa-clone" aria-hidden="true"></i>
                            &nbsp;&nbsp; Production
                          </Link>
                        </li>
                      )}
                    <li className="nav-item">
                      <Link
                        to="/kitchen-transfer"
                        className={`nav-link ${active === "/kitchen-transfer" ? "active" : ""
                          }`}
                        onClick={() => setActive("/kitchen-transfer")}
                      >
                        <i className="fa fa-clone" aria-hidden="true"></i>
                        &nbsp;&nbsp;
                        {receiveData === "production"
                          ? "Transfer To Handi"
                          : "Transfer Receive"}
                        {(receiveData === "kitchen_manager") && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.TransferItemCount}
                            </span>
                          </>
                        )}
                        {(receiveData === "kitchen") && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.ReceiveTransfer}
                            </span>
                          </>
                        )}
                      </Link>
                    </li>
                  </>
                )}
              {/* {(receiveData === "kitchen" || receiveData === "kitchen_manager") && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/kitchen-to-kitchen-transfer"
                      className={`nav-link ${
                        active === "/kitchen-to-kitchen-transfer"
                          ? "active"
                          : ""
                      }`}
                      onClick={() => setActive("/kitchen-to-kitchen-transfer")}
                    >
                      <i className="fa fa-clone" aria-hidden="true"></i>
                      &nbsp;&nbsp; Inter-Kitchen Transfer
                      {(receiveData === "kitchen" || receiveData === "kitchen_manager") && (
                        <>
                          <span className="badge bg-danger ms-2">
                            {badgeNotification?.InterTransferItemCount}
                          </span>
                        </>
                      )}
                    </Link>
                  </li>
                </>
              )} */}
              {(receiveData === "kitchen" ||
                receiveData === "kitchen_manager" ||
                receiveData === "production" || receiveData === "admin_viewer") && (
                  <>
                    <li className="nav-item">
                      <Link
                        to="/damage"
                        className={`nav-link ${active === "/damage" ? "active" : ""
                          }`}
                        onClick={() => setActive("/damage")}
                      >
                        <i className="fa fa-clone" aria-hidden="true"></i>
                        &nbsp;&nbsp;{" "}
                        {receiveData === "production"
                          ? "Return From Handi"
                          : "Return to Production"}
                        {receiveData === "production" && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.ReturnCount}
                            </span>
                          </>
                        )}
                      </Link>
                    </li>
                  </>
                )}
              {(receiveData === "production" ||
                receiveData === "gm" ||
                receiveData === "admin" || receiveData === "admin_viewer") && (
                  <>
                    <li className="nav-item">
                      <Link
                        to="/damage-return"
                        className={`nav-link ${active === "/damage-return" ? "active" : ""
                          }`}
                        onClick={() => setActive("/damage-return")}
                      >
                        <i className="fa fa-clone" aria-hidden="true"></i>
                        &nbsp;&nbsp; Damage
                        {receiveData === "gm" && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.NotApprovedByGMDamageReturn}
                            </span>
                          </>
                        )}
                        {receiveData === "admin" && (
                          <>
                            <span className="badge bg-danger ms-2">
                              {badgeNotification?.NotApprovedByAdminDamageReturn}
                            </span>
                          </>
                        )}
                      </Link>
                    </li>
                  </>
                )}

              {(
                receiveData === "supply_chain" ||
                receiveData === "production" ||
                receiveData === "kitchen" ||
                receiveData === "kitchen_manager") && (
                  <>
                    {/* {receiveData !== "admin" && ( */}
                    <>
                      <li className="nav-item">
                        <p className="reportWatermark nav-link">Reports</p>
                      </li>
                      <>
                        <li className="nav-item">
                          <Link
                            to="/product-wise-stock"
                            className={`nav-link ${active === "/product-wise-stock" ? "active" : ""
                              }`}
                            onClick={() => setActive("/product-wise-stock")}
                          >
                            <i
                              className="fa fa-share-square"
                              aria-hidden="true"
                            ></i>
                            &nbsp;&nbsp; Product Wise Stock
                          </Link>
                        </li>
                      </>
                    </>
                    {/* )} */}
                    {/* {(receiveData === "admin" || receiveData === "admin_viewer" || receiveData === "supply_chain") && */}
                    {(receiveData === "supply_chain" || receiveData === "admin" || receiveData === "admin_viewer") && (
                      <>
                        <li className="nav-item">
                          <Link
                            to="/product-ledger/:id"
                            className={`nav-link ${active === "/product-ledger/:id" ? "active" : ""
                              }`}
                            onClick={() => setActive("/product-ledger/:id")}
                          >
                            <i
                              className="fa fa-share-square"
                              aria-hidden="true"
                            ></i>
                            &nbsp;&nbsp; Product Wise Ledger
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/vendor-ledger-summary"
                            className={`nav-link ${active === "/reports/vendor-ledger-summary"
                              ? "active"
                              : ""
                              }`}
                            onClick={() =>
                              setActive("/reports/vendor-ledger-summary")
                            }
                          >
                            <i
                              className="fa fa-share-square"
                              aria-hidden="true"
                            ></i>
                            &nbsp;&nbsp; Vendor Ledger Summary
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/vendor-ledger"
                            className={`nav-link ${active === "/reports/vendor-ledger"
                              ? "active"
                              : ""
                              }`}
                            onClick={() => setActive("/reports/vendor-ledger")}
                          >
                            <i
                              className="fa fa-share-square"
                              aria-hidden="true"
                            ></i>
                            &nbsp;&nbsp; Vendor Ledger
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/date-wise-issue-out-report"
                            className={`nav-link ${active === "/reports/date-wise-issue-out-report"
                              ? "active"
                              : ""
                              }`}
                            onClick={() =>
                              setActive("/reports/date-wise-issue-out-report")
                            }
                          >
                            <i
                              className="fa fa-share-square"
                              aria-hidden="true"
                            ></i>
                            &nbsp;&nbsp; Department Wise Issue / Out Report
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/product-wise-purchase-in-report"
                            className={`nav-link ${active ===
                              "/reports/product-wise-purchase-in-report"
                              ? "active"
                              : ""
                              }`}
                            onClick={() =>
                              setActive(
                                "/reports/product-wise-purchase-in-report",
                              )
                            }
                          >
                            <i
                              className="fa fa-share-square"
                              aria-hidden="true"
                            ></i>
                            &nbsp;&nbsp; Product Wise Purchase (In) Report
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/reports/product-wise-issue-out-report"
                            className={`nav-link ${active ===
                              "/reports/product-wise-issue-out-report"
                              ? "active"
                              : ""
                              }`}
                            onClick={() =>
                              setActive(
                                "/reports/product-wise-issue-out-report",
                              )
                            }
                          >
                            <i
                              className="fa fa-share-square"
                              aria-hidden="true"
                            ></i>
                            &nbsp;&nbsp; Product Wise Issue (Out) Report
                          </Link>
                        </li>
                      </>
                    )}

                  </>
                )}

              {(receiveData === "admin" || receiveData === "admin_viewer") && (
                <>
                  <li className="nav-item">
                    <p className="reportWatermark nav-link">Reports</p>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/reports"
                      className={`nav-link ${active === "/reports" ? "active" : ""
                        }`}
                      onClick={() => setActive("/reports")}
                    >
                      <i className="fa fa-tachometer" aria-hidden="true"></i>
                      <span>Reports</span>
                    </Link>
                  </li>
                </>
              )}

              {/* Assets */}
              {/* {(receiveData === "admin" || receiveData === "supply_chain") && <Assets onMenuClick={handleSidebarClick} active={active} />} */}
              {/* Sales */}
              {/* {(receiveData === "admin" || receiveData === "depot" || receiveData === "supply_chain") && (
                <Sales role={receiveData} onMenuClick={handleSidebarClick} active={active} />
              )} */}
              {/* Secondary Sales */}
              {/* {receiveData === "admin" && <SecondarySales onMenuClick={handleSidebarClick} active={active} />} */}
              {/* Reports */}

              {/* {(receiveData === "admin" ||
                receiveData === "supply_chain" ||
                receiveData === "production" ||
                receiveData === "depot") && <Production role={receiveData} />} */}

              {/* <Production role={receiveData} onMenuClick={handleSidebarClick} active={active} /> */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
